import apiClient from './config';

// Definimos la estructura esperada de los datos
export interface OSINTCount {
  date: string;
  count: number;
}

export interface OSINTCountsResponse {
  phishing_attempts: OSINTCount[];
  vulnerabilities: OSINTCount[];
  data_breaches: OSINTCount[];
}

export interface OSINTTotalsResponse {
  dehashed_count: number;
  ip_vulnerabilities_count: number;
  typosquatting_names_count: number;
}

// Función para obtener los conteos de OSINT desde la API
export const getOSINTCounts = async (): Promise<OSINTCountsResponse> => {
  try {
    const response = await apiClient.get<OSINTCountsResponse>('/osint_counts');
    return response.data;
  } catch (error) {
    console.error('Error fetching OSINT counts:', error);
    throw error;
  }
};


export const getOSINTTotals = async (): Promise<OSINTTotalsResponse> => {
  try {
    // Ajusta la URL según tu endpoint real
    const response = await apiClient.get<OSINTTotalsResponse>('/osint_counts/totals');
    return response.data;
  } catch (error) {
    console.error('Error fetching OSINT totals:', error);
    throw error;
  }
};